import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
  faTiktok,
  faXTwitter,
  faYoutube,
  faPinterestP
} from "@fortawesome/free-brands-svg-icons";
import "./RightElements.css";

const SocialElements = () => (
  <div className="social-elements">
    <a href="#" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
    <a href="#" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} /></a>
  </div>
);

export default SocialElements;
